import {
    completeRequest,
    queueRequest,
    registerHandler,
} from './request_queue.js';
import { httpPOST } from './utils.js';
import { isConnected } from '../selectors/offline';

registerHandler('caliper-navigation', (content_id, page_index, page_label, timestamp) => {
    return httpPOST('/api/caliper/navigated_to_page', {
        content_id,
        page_index,
        page_label,
        // This needs to be recalculated before each request attempt
        delta: Date.now() - timestamp,
    });
});

const cacheCaliperRequest = ({ id, ...request }) => (dispatch, getState) => {
    dispatch(completeRequest({ id }));
    const requests = JSON.parse(localStorage.getItem('caliperRequests')) || [];
    requests.push(request);
    localStorage.setItem('caliperRequests', JSON.stringify(requests));
};

const _sendPageRead = pageRead => dispatch =>
    dispatch(
        queueRequest('httpPOST', '/api/v3/page_read/', {
            ...pageRead,
            delta: Date.now() - pageRead.timestamp,
        })
    ).catch(({ message: id }) =>
        dispatch(cacheCaliperRequest({ ...pageRead, id }))
    );
export const sendPageRead = (page_index, pageLabel, slug, section) => (
    dispatch,
    getState
) => {
    dispatch(
        _sendPageRead({
            page_index: page_index,
            page_label: pageLabel,
            section: section.resource_uri,
            slug,
            timestamp: Date.now(),
            while_offline: !isConnected(getState()),
        })
    );
};

const _sendNavigatedToPage = (content_id, page_index, page_label, timestamp) => dispatch =>
    dispatch(
        queueRequest('caliper-navigation', content_id, page_index, page_label, timestamp)
    ).catch(({ message: id }) =>
        dispatch(
            cacheCaliperRequest({
                content_id,
                id,
                page_index,
                page_label,
                timestamp,
            })
        )
    );
export const sendNavigatedToPage = (content_id, page_index, page_label) => dispatch => {
    dispatch(_sendNavigatedToPage(content_id, page_index, page_label, Date.now()));
};

const _batchRequests = () => {
    const requests = JSON.parse(localStorage.getItem('caliperRequests')) || [];
    localStorage.setItem('caliperRequests', JSON.stringify([]));
    return requests.reduce(
        (acc, request) => {
            const key = request.hasOwnProperty('page_index')
                ? 'page_reads'
                : 'navigated_to';
            return {
                ...acc,
                [key]: [
                    ...acc[key],
                    { ...request, delta: Date.now() - request.timestamp },
                ],
            };
        },
        {
            page_reads: [],
            navigated_to: [],
        }
    );
};

export const sendCachedRequests = () => dispatch => {
    const { page_reads, navigated_to } = _batchRequests();
    navigated_to.length &&
        dispatch(
            queueRequest('httpPOST', '/api/v3/navigation_batch/', navigated_to)
        ).catch(() => {
            navigated_to.forEach(request =>
                dispatch(cacheCaliperRequest(request))
            );
        });
    page_reads.length &&
        dispatch(
            queueRequest('httpPOST', '/api/v3/page_read_batch/', page_reads)
        ).catch(() => {
            page_reads.forEach(request =>
                dispatch(cacheCaliperRequest(request))
            );
        });
};



// WEBPACK FOOTER //
// ./src/actions/events.js